import Tooltip from '@carvana/showroom-tooltip';
import InfoStandardSmall from '~/icons/srp/InfoStandardSmall';
import formatAndDropDecimal from '~/utilities/srp/formatAndDropDecimal';

type OwnProps = {
  equity: number;
  tradeValue: number;
  loanBalance: number;
};

const TradeToolTip = ({ equity, tradeValue, loanBalance }: OwnProps) => (
  <Tooltip
    content={
      <>
        <div className="mb-12 flex flex-col gap-8 border-b border-solid border-grey-2 pb-12 text-white">
          <div className="flex w-full justify-between">
            <div>Your Offer</div>
            <div>${formatAndDropDecimal(tradeValue)}</div>
          </div>
          <div className="flex w-full justify-between">
            <div>Loan Balance</div>
            <div>-${formatAndDropDecimal(loanBalance)}</div>
          </div>
        </div>
        <div className="flex w-full justify-between gap-8 font-bold">
          <div>
            Trade-in{' '}
            {equity < 0 ? 'Balance Due' : 'value applied to your purchase'}{' '}
          </div>
          <div>
            {equity < 0 ? '-$' : '$'}
            {formatAndDropDecimal(Math.abs(equity))}
          </div>
        </div>
      </>
    }
    title={`How was my trade-in ${
      equity < 0 ? 'balance' : 'value'
    } calculated?`}
    direction="bottom"
    display={{
      width: 265,
      contentOffsetX: -50,
      arrowOffsetX: 50
    }}
  >
    <InfoStandardSmall />
  </Tooltip>
);

export default TradeToolTip;
